<template>
  <the-header/>
    <project-gallery></project-gallery>
  <the-footer/>
</template>

<script>
import ProjectGallery from './ProjectGallery.vue'
export default {
  components: {
    ProjectGallery
  },
  mounted(){
 
  }
}
</script>